import request from '@/services/request'

/**
 * 新闻列表
 * */
export function newsList(params) {
  return request({
    url: '/news/newsList',
    method: 'get',
    params
  })
}

/**
 * 新闻详情
 * */
export function newsDetail(params) {
  return request({
    url: '/news/detail',
    method: 'get',
    params
  })
}

/**
 * 灵匠提交
 * */
export function jiangCollect(params) {
  return request({
    url: '/apply/add',
    method: 'get',
    params
  })
}

/**
 * 灵匠提交
 * */
export function jiangCollectList(params) {
  return request({
    url: '/apply/list',
    method: 'get',
    params
  })
}

/**
 * 用户咨询提交
 * */
export function addEdu(params) {
  return request({
    url: '/apply/addEdu',
    method: 'get',
    params
  })
}

/**
 * 用户咨询列表
 * */
export function listEdu(params) {
  return request({
    url: '/apply/listEdu',
    method: 'get',
    params
  })
}

// 方案列表。首页和方案集合页
export function planList(params) {
  return request({
    url: '/adsense/adList?catid=13',
    method: 'get',
    params
  })
}

// 方案列表。首页和方案集合页
export function planListHeader(params) {
  return request({
    url: '/solution/listNew',
    method: 'get',
    params
  })
}

/**
 * 方案详情
 * */
export function planDetail(params) {
  return request({
    url: '/solution/detail',
    method: 'get',
    params
  })
}

/*
   客户案例
*/
export function caseList(params) {
  return request({
    url: '/news/caseList',
    method: 'get',
    params
  })
}

/**
 * 首页
 * */
export function index(params) {
  return request({
    url: '/adsense/adList?cateid=9',
    method: 'get',
    params
  })
}
